<div class="sub-side-menu"  #myLabel >
  <!-- <h2>LPL ISA</h2> -->
  <h3>{{heading}}</h3>
  <nav class="sub-side-menu-list" *ngFor="let item of subMenuItems;let i= index" >
      <a class="nav-item"   [ngClass]="{'active': item.isActive === true}"  (click)="showOrHideManually(item,$event)" routerLink="{{item.url}}"  *ngIf="!item.roles || item.roles?.includes(vaService.activeAgent.role)"><span><i class="icon {{item.styleClass}}"></i></span>{{item.label}}<span class="badge" *ngIf="item.badge">{{badgeData[item.badge]}}</span><sup *ngIf="item.beta">Beta</sup></a>
  </nav>
</div>

